import { RidangoReduxAction } from '@ridango/core';

import { tassign } from 'tassign';

import { LoginActions } from './login.actions';

export interface LoginCredentials {
    email: string;
    password: string;
    lang?: string;
    rememberMe?: boolean;
    ondemandRequest?: boolean;
    callback_url?: string;
}

export interface LoginState {
    isAuthenticated: boolean;
    isValidCredentials: boolean;
    forcePasswordReset: boolean;
    forceTermsAgreement: boolean;
    forceTermsReason: string;
    loading: boolean;
    error: any;
    authAccessToken: string;
    verificationCode: string;
    termsModalVisible: boolean;
}

export const LOGIN_INITIAL_STATE: LoginState = {
    isAuthenticated: false,
    isValidCredentials: false,
    forcePasswordReset: false,
    forceTermsAgreement: false,
    forceTermsReason: null,
    loading: false,
    error: null,
    authAccessToken: null,
    verificationCode: null,
    termsModalVisible: false
};

export function loginReducer(state: LoginState = LOGIN_INITIAL_STATE, action: RidangoReduxAction): LoginState {
    switch (action.type) {
        case LoginActions.LOGIN:
        case LoginActions.LOGIN_AUTH_TOKEN_ONLY:
            return {
                ...state,
                forcePasswordReset: false,
                forceTermsAgreement: false,
                loading: true
            };

        case LoginActions.LOGIN_ID_CARD:
        case LoginActions.LOGIN_OIDC_EXCHANGE:
            return {
                ...state,
                loading: true
            };

        case LoginActions.LOGIN_MOBILE_ID:
        case LoginActions.LOGIN_SMART_ID:
            return {
                ...state,
                verificationCode: action.payload.verificationCode,
                loading: true
            };

        case LoginActions.CANCEL_CHALLENGE_POLLING: {
            return {
                ...state,
                loading: false,
                isAuthenticated: false,
                verificationCode: null,
                error: null
            };
        }

        case LoginActions.LOGIN_CREDENTIAL_SUCCESS:
            return {
                ...state,
                isValidCredentials: true
            };

        case LoginActions.LOGIN_SUCCESS:
            return {
                ...state,
                verificationCode: null,
                isAuthenticated: true,
                loading: false,
                error: null
            };

        case LoginActions.LOGIN_SUCCESS_AUTH_TOKEN_ONLY:
            return {
                ...state,
                isValidCredentials: true,
                loading: false,
                error: null,
                authAccessToken: action.payload
            };

        case LoginActions.LOGIN_FAIL:
            return {
                ...state,
                verificationCode: null,
                isAuthenticated: false,
                loading: false,
                error: action.payload
            };

        case LoginActions.LOGIN_FORCE_PASSWORD_RESET:
            return {
                ...state,
                forcePasswordReset: action.payload,
                error: action.payload ? state.error : null
            };

        case LoginActions.LOGIN_FORCE_AGREEMENT:
            return {
                ...state,
                forceTermsAgreement: true,
                forceTermsReason: action.payload
            };

        case LoginActions.LOGIN_RESET_FORCED_AGREEMENT:
            return {
                ...state,
                forceTermsAgreement: false,
                forceTermsReason: null
            };

        case LoginActions.LOGIN_RESET:
            return tassign(state, { ...LOGIN_INITIAL_STATE });

        case LoginActions.LOGOUT:
            return {
                ...state,
                ...LOGIN_INITIAL_STATE
            };

        case LoginActions.SHOW_TERMS_MODAL:
            return tassign(state, { termsModalVisible: true });

        case LoginActions.HIDE_TERMS_MODAL:
            return tassign(state, { termsModalVisible: false });
    }

    return state;
}
